"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragElement = void 0;

var DragComponent_1 = require("../Component/DragComponent");
/**
 * `DragComponent` for the `PolygonRegion` class.
 */


var DragElement = /*#__PURE__*/function (_DragComponent_1$Drag) {
  _inherits(DragElement, _DragComponent_1$Drag);

  /**
   * Creates a new `DragElement`.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function DragElement(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, DragElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DragElement).call(this, paper, paperRect, regionData, callbacks));
    _this.dragNode = paper.rect(_this.x, _this.y, _this.width, _this.height);

    _this.dragNode.addClass("dragRectStyle");

    _this.node.add(_this.dragNode);

    _this.subscribeToDragEvents();

    return _this;
  }
  /**
   * Redraws the componnent.
   */


  _createClass(DragElement, [{
    key: "redraw",
    value: function redraw() {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.dragNode.attr({
          x: _this2.x,
          y: _this2.y,
          width: _this2.width,
          height: _this2.height
        });
      });
    }
  }]);

  return DragElement;
}(DragComponent_1.DragComponent);

exports.DragElement = DragElement;